var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.7 12.3 18 20l7.7 7.7-2.3 2.3-10-10 10-10z"
})));
export default SvgChevronLeft;